var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.019 2.93061V4.86766H0V2.93061C0 1.8688 0.868759 1 1.93061 1H4.18299V2.90488C4.18299 3.25882 4.47259 3.54842 4.82652 3.54842C5.18046 3.54842 5.47006 3.25882 5.47006 2.90488V1H12.549V2.90488C12.549 3.25882 12.8386 3.54842 13.1925 3.54842C13.5464 3.54842 13.836 3.25882 13.836 2.90488V1H16.0884C17.1503 1 18.019 1.8688 18.019 2.93061Z",
    fill: "#F58634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8705 12.5962H17.6263L12.227 17.4098V13.2397C12.227 12.8858 12.5166 12.5962 12.8705 12.5962Z",
    fill: "#F58634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0189 6.1543V11.309H12.8706C11.8088 11.309 10.94 12.1778 10.94 13.2396V17.7573H1.93049C0.868637 17.7573 -0.00012207 16.8885 -0.00012207 15.8267V6.1543H18.0189Z",
    fill: "#F58634"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4814 0.634039V1.24269H4.23871V0.634039C4.23871 0.285325 4.51832 0 4.86005 0C5.20179 0 5.4814 0.285325 5.4814 0.634039Z",
    fill: "#F58634"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8245 0.634039V1.24269H12.5818V0.634039C12.5818 0.285325 12.8614 0 13.2031 0C13.5449 0 13.8245 0.285325 13.8245 0.634039Z",
    fill: "#F58634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.12ece8d8331abf18f4386196135763a0.svg";
export { ForwardRef as ReactComponent };